var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"stickers-widget"},[_c('Stickers',{style:(_vm.stickersStyle),attrs:{"always-enabled":"","container":_vm.container},on:{"click":_vm.displayStickers,"closeClick":_vm.hideStickers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }